import { DebouncedLoader } from 'components';
import { TabPane } from 'semantic-ui-react';
import { SalesChannelAvailabilityTable } from './SalesChannelAvailabilityTable';
import { useSalesChannelAvailability } from './useSalesChannelAvailability';

export const SalesChannelAvailability = () => {
    const { isFetching, salesChannelAvailability } = useSalesChannelAvailability();

  if (isFetching) return <DebouncedLoader />;

  return (
    <TabPane>
      {salesChannelAvailability ? (
        <SalesChannelAvailabilityTable salesChannelAvailability={salesChannelAvailability} />
      ) : null}    
    </TabPane>
  );
};